// Create React App inlines REACT_APP_* via process.env at build time
const env = process.env;

export const CLD_CLOUD = env.REACT_APP_CLD_CLOUD || "";
export const CLD_PRESET_WALLET_QR =
  env.REACT_APP_CLD_PRESET_WALLET_QR || "bitly_wallet_qr";
export const CLD_PRESET_ORDER_PROOF =
  env.REACT_APP_CLD_PRESET_ORDER_PROOF || "bitly_order_proofs";

export async function uploadToCloudinary(file, preset) {
  const cloud = CLD_CLOUD;

  if (!cloud || !preset) {
    throw new Error(
      "Cloudinary is not configured. Set REACT_APP_CLD_CLOUD and create unsigned upload presets in Cloudinary."
    );
  }

  const body = new FormData();
  body.append("file", file);
  body.append("upload_preset", preset);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud}/image/upload`, {
    method: "POST",
    body,
  });

  const json = await res.json();
  if (!res.ok) {
    const msg = json?.error?.message || "Cloudinary upload failed";
    throw new Error(msg);
  }

  return {
    url: json.secure_url,
    publicId: json.public_id,
    bytes: json.bytes,
    format: json.format,
    width: json.width,
    height: json.height,
  };
}

export function cloudinaryImageUrl(url, { width = 480, quality = "auto" } = {}) {
  if (!url || !url.includes("res.cloudinary.com")) return url;
  return url.replace("/upload/", `/upload/w_${width},q_${quality},f_auto/`);
}
